import { Controller } from "@hotwired/stimulus"

// Animates a numeric value from 0 to its rendered value on connect.
// Works for integers and decimals automatically.
// Usage: <p data-controller="count-up">847</p>
export default class extends Controller {
  static values = {
    duration: { type: Number, default: 900 }
  }

  connect() {
    const raw = this.element.textContent.trim()
    const end = parseFloat(raw.replace(/[\s,]/g, ''))
    if (isNaN(end) || end <= 0) return

    this.isDecimal = raw.includes('.')
    this.endValue = end
    requestAnimationFrame(() => this.animate())
  }

  animate() {
    const duration = this.durationValue
    const end = this.endValue
    const isDecimal = this.isDecimal
    const startTime = performance.now()

    const step = (now) => {
      const elapsed = now - startTime
      const progress = Math.min(elapsed / duration, 1)
      // ease-out-quart: fast start, smooth deceleration
      const eased = 1 - Math.pow(1 - progress, 4)
      const current = end * eased

      this.element.textContent = isDecimal
        ? current.toFixed(1)
        : Math.round(current).toLocaleString()

      if (progress < 1) requestAnimationFrame(step)
    }

    this.element.textContent = isDecimal ? '0.0' : '0'
    requestAnimationFrame(step)
  }
}
